export const PolicyOwner = {
  CLIENT: 'Client',
  PARTNER: 'Partner',
  JOINT: 'Joint',
  NOT_SET: 'NotSet'
};
